import {RemotePatchAdherenceDigitalPayment} from 'data/usecases';
import {PatchAdherenceDigitalPayment} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {MyPaymentsFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makePatchAdherenceDigitalPayment = (): PatchAdherenceDigitalPayment =>
	new RemotePatchAdherenceDigitalPayment(
		makeBFFApiUrl(MyPaymentsFlowEndPoints.adherenceDigitalPayment),
		makeAuthorizeHttpClientDecorator(),
	);
